import { normalizeModule, type ModuleType } from '@/lib/moduleContext';

export interface DailyGoalDefaults {
  questions: number;
  /** Minutos. */
  time: number;
  weeklySimulations: number;
}

const FALLBACK: DailyGoalDefaults = { questions: 20, time: 90, weeklySimulations: 2 };

const OVERRIDES: Partial<Record<ModuleType, DailyGoalDefaults>> = {
  concursos: { questions: 30, time: 120, weeklySimulations: 2 },
};

/**
 * Defaults usados quando o usuário ainda não salvou metas diárias para o módulo.
 * Fonte única de verdade compartilhada por HeaderProgressIndicator e cada *Settings.tsx.
 * Aceita tanto slugs do sidebar ('carreiras-juridicas') quanto do enum DB ('juridicas').
 */
export function getDailyGoalDefaults(moduleType: ModuleType | string): DailyGoalDefaults {
  const normalized = normalizeModule(moduleType);
  return OVERRIDES[normalized] ?? FALLBACK;
}
